export default "__VITE_ASSET__ClOyFQoE__"